export default "__VITE_ASSET__CGJ8ENhE__"